import { Quill } from "@vueup/vue-quill";

export const useInitializeKeyboard = (quill: any) => {
  const Keyboard = Quill.import("modules/keyboard");

  const customBinding = {
    key: Keyboard.keys.BACKSPACE,
    handler: (range: any, context: any) => {
      const [line, offset] = quill.getLine(range.index);
      if (!line) return true;

      if (offset == 0) {
        const formats = line.formats?.() ?? quill.getFormat(range.index);
        if (formats.align === "center") {
          quill.formatLine(range.index, 1, "align", false);
          return false; // Prevent default backspace
        }
      }

      return true; // Allow default backspace behavior
    },
  };

  // Prepend to the beginning of the bindings array so it runs first
  if (!quill.keyboard.bindings[Keyboard.keys.BACKSPACE]) {
    quill.keyboard.bindings[Keyboard.keys.BACKSPACE] = [];
  }
  quill.keyboard.bindings[Keyboard.keys.BACKSPACE].unshift(customBinding);
};
